import React from 'react';

import MultiselectTwoSides from 'react-multiselect-two-sides';
import 'react-multiselect-two-sides/style.css';
import './multi-select.css';

class MultiSelect extends React.Component {
    render() {
        return (
            <MultiselectTwoSides
                className='msts_theme'
                labelKey='label'
                {...this.props}/>
        );
    }
}

export default MultiSelect;



// WEBPACK FOOTER //
// ./src/components/multi-select/multi-select.js